// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

//LOCAL
export const environment = {
  BASE_URL: 'https://publishersadmin.sambanetworks.com',

  APP_URL: 'https://publishersadmin.sambanetworks.com',
  API_URL: 'https://pubadminapi.sambanetworks.com',
  production: false
};

//STAGING
// export const environment = {
//   BASE_URL: 'http://saapstaging.cloudapp.net:84',

//   APP_URL: 'http://saapstaging.cloudapp.net:84',
//   API_URL: 'https://saapstaging.cloudapp.net:8181',
//   production: false
// };

//DEVELOPMENT
// export const environment = {
//   BASE_URL: 'http://saapstaging.cloudapp.net:8084',

//   APP_URL: 'http://saapstaging.cloudapp.net:8084',
//   API_URL: 'http://saapstaging.cloudapp.net:8081',
//   production: false
// };

//PRODUCTION
// export const environment = {
//   BASE_URL: 'https://publishersadmin.sambanetworks.com',

//   APP_URL: 'http://publishersadmin.sambanetworks.com',
//   API_URL: 'https://pubadminapi.sambanetworks.com',
//   production: false
// };



// WEBPACK FOOTER //
// ./src/environments/environment.ts